export default function tryClipboardCopy() {
  let success = false;

  try {
    success = document.execCommand('copy');
  } catch (err) {
    // ignore
  }

  return success;
}



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/try-clipboard-copy.js
 **/